var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mormal-axis ma"}),_c('div',{staticClass:"active-axis-parent ma"},[_c('div',{staticClass:"active-axis",style:({ width: _vm.params.persent + '%', backgroundColor: _vm.params.color })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }